import { useState } from 'react'

import { Button } from './button'

interface CopyToClipboardProps {
  text: string
  label?: string
  copiedLabel?: string
}

export function CopyToClipboard({ text, label = 'Copy', copiedLabel = 'Copied' }: CopyToClipboardProps) {
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Button variant="link" size="sm" className="w-fit pl-0" onClick={handleCopy}>
      {copied ? copiedLabel : label}
    </Button>
  )
}
